import React from "react";
import "../spinner.scss";
import "../utilities.scss";

export default function DonationItem({
  item,
  onClickEditItem,
  onClickDeleteItem,
  frequency,
  isLoading,
}) {
  return (
    <div
      className={`order-item__wrapper order-item__wrapper--donation-summary content-blur${
        (isLoading && " spinner--after spinner--centered content-blurred") || ""
      }`}
    >
      <div className={`order-item order-item--donation-summary`}>
        <h3 className="order-item__title order-item__title--donation-summary">
          {item.attributes.title}
        </h3>

        <div className="order-item__amount-wrapper">
          <button
            id={item.id}
            type="button"
            className="order-item__amount"
            key={item.id}
            onClick={() => onClickEditItem(item)}
          >
            {frequency === "monthly"
              ? item.attributes.total_price.formatted + " /mo"
              : item.attributes.total_price.formatted}
          </button>
        </div>

        <button
          className="order-item__delete-button order-item__delete-button--donation-summary"
          onClick={() => onClickDeleteItem(item)}
        >
          <span className="visually-hidden">
            Remove {item.attributes.title} from cart
          </span>
          <span aria-hidden>×</span>
        </button>
      </div>
    </div>
  );
}
